import { TeamCalendarEvent } from 'data/schemas/TeamCalendar';

export function startOfMonth(date: Date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function endOfMonth(date: Date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export function startOfCalendarGrid(date: Date) {
    const monthStart = startOfMonth(date);
    return new Date(monthStart.getFullYear(), monthStart.getMonth(), monthStart.getDate() - monthStart.getDay());
}

export function endOfCalendarGrid(date: Date) {
    const monthEnd = endOfMonth(date);
    return new Date(monthEnd.getFullYear(), monthEnd.getMonth(), monthEnd.getDate() + (6 - monthEnd.getDay()));
}

export function formatMonthTitle(date: Date) {
    return new Intl.DateTimeFormat('en-US', {
        month: 'long',
        year: 'numeric'
    }).format(date);
}

export function formatDateLabel(date: Date) {
    return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    }).format(date);
}

export function formatTimeLabel(value: string) {
    return new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(value));
}

export function toDateKey(date: Date) {
    return date.toISOString().slice(0, 10);
}

export function toInputDateTimeValue(value?: string) {
    if (!value) {
        return '';
    }

    const date = new Date(value);
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60 * 1000);

    return localDate.toISOString().slice(0, 16);
}

export function buildCalendarCells(currentMonth: Date) {
    const start = startOfCalendarGrid(currentMonth);
    const end = endOfCalendarGrid(currentMonth);
    const cells: Date[] = [];

    for (let cursor = new Date(start); cursor <= end; cursor.setDate(cursor.getDate() + 1)) {
        cells.push(new Date(cursor));
    }

    return cells;
}

export function getMonthRange(currentMonth: Date) {
    return {
        startDate: startOfCalendarGrid(currentMonth).toISOString(),
        endDate: endOfCalendarGrid(currentMonth).toISOString()
    };
}

export function sameDate(left: Date, right: Date) {
    return toDateKey(left) === toDateKey(right);
}

export function isSameMonth(left: Date, right: Date) {
    return left.getFullYear() === right.getFullYear() && left.getMonth() === right.getMonth();
}

export function getEventsForDate(date: Date, events: TeamCalendarEvent[]) {
    const dayStart = new Date(date);
    dayStart.setHours(0, 0, 0, 0);

    const dayEnd = new Date(date);
    dayEnd.setHours(23, 59, 59, 999);

    return events.filter(event => {
        const start = new Date(event.startAt);
        const end = new Date(event.endAt);
        return start <= dayEnd && end >= dayStart;
    });
}
